import { useContext, useMemo, useCallback } from "react";
import { OrderedSet } from "immutable";
import MessageFavoriteFieldsContext from "views/components/contexts/MessageFavoriteFieldsContext";
import FieldTypeMapping from "views/logic/fieldtypes/FieldTypeMapping";
import FieldType from "views/logic/fieldtypes/FieldType";
import { defaultCompare } from "logic/DefaultCompare";
const useFormattedFields = (favoriteFields) => {
  const { message, messageFields: fieldTypes } = useContext(MessageFavoriteFieldsContext);
  const fieldsMapper = useCallback(
    (field) => {
      var _a;
      const { type } = fieldTypes.find(
        (t) => t.name === field,
        void 0,
        FieldTypeMapping.create(field, FieldType.Unknown)
      );
      const value = (_a = message == null ? void 0 : message.formatted_fields) == null ? void 0 : _a[field];
      return { value, field, type, id: field, title: field };
    },
    [fieldTypes, message == null ? void 0 : message.formatted_fields]
  );
  const formattedFavorites = useMemo(() => {
    const formattedFieldSet = OrderedSet(Object.keys(message.formatted_fields));
    return favoriteFields.filter((field) => formattedFieldSet.has(field)).map(fieldsMapper);
  }, [favoriteFields, fieldsMapper, message.formatted_fields]);
  const formattedRest = useMemo(() => {
    const favoriteFieldsSet = OrderedSet(favoriteFields);
    return Object.keys(message.formatted_fields).filter((field) => !favoriteFieldsSet.has(field)).sort((key1, key2) => defaultCompare(key1, key2)).map(fieldsMapper);
  }, [favoriteFields, fieldsMapper, message.formatted_fields]);
  return { formattedFavorites, formattedRest };
};
export default useFormattedFields;
